import { render, staticRenderFns } from "./CurrencySelect.vue?vue&type=template&id=5b8ae46b&scoped=true"
import script from "./CurrencySelect.vue?vue&type=script&lang=js"
export * from "./CurrencySelect.vue?vue&type=script&lang=js"
import style0 from "./CurrencySelect.vue?vue&type=style&index=0&id=5b8ae46b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8ae46b",
  null
  
)

export default component.exports